import { Price } from "src/components/Price";

type ReviewImpactedPriceProps = {
  valueInCents: number;
  comparedValueInCents?: number;
  showZeroAsNone?: boolean;
  hideDisplayDirection?: boolean;
};

export function ReviewImpactedPrice(props: ReviewImpactedPriceProps) {
  const { valueInCents, comparedValueInCents, showZeroAsNone, hideDisplayDirection } = props;
  if ((valueInCents === 0 && showZeroAsNone) || valueInCents === comparedValueInCents) return "None";
  const displayDirection = !hideDisplayDirection && valueInCents > 0;
  return <Price valueInCents={valueInCents} displayDirection={displayDirection} invertColors zeroIs="neutral" />;
}
